<template>
  <div style="width: 100%;">
    <div
      class="row f-row mb-1"
      v-for="(total, idxY) in dataSkeleton"
      v-bind:key="idxY"
    >
      <div class="col col-12">
        <table class="table table-sm table-borderless valuation_table">
          <thead>
            <tr>
              <th colspan="7">
                {{ total.name }}
                <i class="fa fa-plus" style="color:var(--textinactive)"></i>
              </th>
            </tr>
            <tr>
              <td>
                {{ total.totals[0].txt_strats }}
              </td>
              <td>
                {{ total.totals[0].txt_derivatives }}
              </td>
              <td>
                {{ total.totals[0].txt_quantity }}
              </td>
              <td>
                {{ total.totals[0].txt_delta }}
              </td>
              <td>
                {{ total.totals[0].txt_value }}
              </td>
              <td>
                <span v-if="total.totals[0].txt_value_initial != null">
                  {{ total.totals[0].txt_value_initial }}
                </span>
              </td>
              <td>
                <span v-if="total.totals[0].txt_value_initial != null">
                  Change
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="i in 6" :key="i">
                <div class="row f-row justify-content-end">
                  <div class="col col-6"></div>
                  <div class="col col-6"><Skeleton /></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getSkeletonTable } from "@/_core/_helpers/_helpers";
import Skeleton from "primevue/skeleton";

export default {
  name: "SkeletonValuation",
  components: {
    Skeleton
  },
  data() {
    return {
      dataSkeleton: [
        {
          name: "Expired hedges",
          totals: [
            {
              txt_delta: "Delta",
              txt_derivatives: "Expired Derivatives",
              txt_quantity: "Expired quantity",
              txt_strats: "Expired Strategies",
              txt_value: "Valuation on ...",
              txt_value_initial: "Valuation on ..."
            }
          ]
        },
        // {
        //   name: "NEW HEDGES",
        //   totals: [
        //     {
        //       txt_delta: "Delta",
        //       txt_derivatives: "Derivatives",
        //       txt_quantity: "New quantity",
        //       txt_strats: "Strategies",
        //       txt_value: "Valuation on ...",
        //       txt_value_initial: "Valuation on ..."
        //     }
        //   ]
        // },
        // {
        //   name: "OTHER HEDGES",
        //   totals: [
        //     {
        //       txt_delta: "Delta",
        //       txt_derivatives: "Derivatives",
        //       txt_quantity: "Quantity",
        //       txt_strats: "Strategies",
        //       txt_value: "Valuation on ...",
        //       txt_value_initial: "Valuation on ..."
        //     }
        //   ]
        // },
        {
          name: "Open positions",
          totals: [
            {
              txt_delta: "Delta",
              txt_derivatives: "Derivatives",
              txt_quantity: "Quantity",
              txt_strats: "Strategies",
              txt_value: "Valuation on ...",
              txt_value_initial: "Valuation on ..."
            }
          ]
        }
      ],
      skeletonTable: []
    };
  },
  created() {
    this.skeletonTable = getSkeletonTable();
  }
};
</script>

<style scoped></style>
